export default __webpack_public_path__ + "static/media/copy-text-icon.45b27ad1.svg";